import { render } from "./perms.vue?vue&type=template&id=4efbbf56&scoped=true"
import script from "./perms.vue?vue&type=script&lang=js"
export * from "./perms.vue?vue&type=script&lang=js"

import "./perms.vue?vue&type=style&index=0&id=4efbbf56&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4efbbf56"]])

export default __exports__